document.addEventListener('DOMContentLoaded', () => {
  const tabButtons     = document.querySelectorAll('.tab-button');
  const tabContents    = document.querySelectorAll('.tab-content');
  const tabsContainer  = document.querySelector('.tabs');
  const accordionWrap  = document.querySelector('.tabs-accordion');
  const leftButton     = document.querySelector('.tab-control-left');
  const rightButton    = document.querySelector('.tab-control-right');

  let activeTab = document.querySelector('.tab-button.active')?.dataset.tab || null;

  // Handle tab click
  tabButtons.forEach(button => {
    button.addEventListener('click', () => {
      const tabId = button.dataset.tab;
      const content = document.getElementById(tabId);
      const isMobile = window.innerWidth <= 768;
      const isSameAsActive = activeTab === tabId;

      if (isSameAsActive) {
        if (isMobile) {
          button.classList.remove('active');
          content.classList.remove('active');
          activeTab = null;
        }
        return;
      }

      tabButtons.forEach(btn => btn.classList.remove('active'));
      tabContents.forEach(c => c.classList.remove('active'));

      button.classList.add('active');
      content.classList.add('active');
      activeTab = tabId;

      isMobile
        ? button.scrollIntoView({ behavior: 'smooth', block: 'center' })
        : centerTab(button);
    });
  });

  // Center tab horizontally
  function centerTab(el) {
    const rect = tabsContainer.getBoundingClientRect();
    const offset = el.getBoundingClientRect().left - rect.left - (rect.width - el.offsetWidth) / 2;
    tabsContainer.scrollBy({ left: offset, behavior: 'smooth' });
  }

  // Arrow navigation
  leftButton?.addEventListener('click', () => {
    tabsContainer.scrollBy({ left: -tabsContainer.clientWidth, behavior: 'smooth' });
  });
  rightButton?.addEventListener('click', () => {
    tabsContainer.scrollBy({ left: tabsContainer.clientWidth, behavior: 'smooth' });
  });

  // Rearrange content for mobile
  function rearrangeTabs() {
    const isMobile = window.innerWidth <= 768;

    tabButtons.forEach(button => {
      const content = document.getElementById(button.dataset.tab);
      if (isMobile && button.nextElementSibling !== content) {
        button.insertAdjacentElement('afterend', content);
      } else if (!isMobile && content.parentElement !== accordionWrap) {
        accordionWrap.appendChild(content);
      }
    });

    // Reapply active state (important when moving elements)
    if (activeTab) {
      document.querySelector(`.tab-button[data-tab="${activeTab}"]`)?.classList.add('active');
      document.getElementById(activeTab)?.classList.add('active');
    }
  }

  // Initial setup and on resize
  rearrangeTabs();
  window.addEventListener('resize', rearrangeTabs);
});